import { gql } from '@apollo/client';
import { NewDatasetStorageLocationInput } from 'types/Dataset';

const addDatasetStorageLocation = (
    datasetUri: string,
    input: NewDatasetStorageLocationInput,
) => {
    return {
        variables: { datasetUri, input },
        mutation: gql`
            mutation CreateDatasetStorageLocation(
                $datasetUri: String
                $input: NewDatasetStorageLocationInput
            ) {
                createDatasetStorageLocation(
                    datasetUri: $datasetUri
                    input: $input
                ) {
                    locationUri
                    S3Prefix
                }
            }
        `,
    };
};

export default addDatasetStorageLocation;
